import 'bootstrap/dist/css/bootstrap.min.css'

export const pageStyles = {
  fontFamily: "Noto Sans JP, sans-serif"
}
